module.exports = __webpack_public_path__ + "static/media/cpeLearning.f6622158.svg";